import { API } from '@aws-amplify/api';

const API_NAME = 'treehacks';

/**
//  * Fetches data for a user
//  * @param {string} userId - The user's id
//  * @returns {Promise<object|null>} The user data or null if error
//  */
export const fetchUserRecord = async (userId) => {
  try {
    const response = await API.get(API_NAME, `/scan/users/${userId}/forms`, {});
    return response;
  } catch (error) {
    console.error('Error fetching user record:', error);
    return null;
  }
};

/**
//  * Fetches data for a judge
//  * @param {string} judgeId - The judge's id
//  * @returns {Promise<object|null>} The judge data or null if error
//  */
export const fetchJudgeRecord = async (judgeId) => {
  try {
    const response = await API.get(API_NAME, `/scan/judges/${judgeId}/forms`, {});
    return response;
  } catch (error) {
    console.error('Error fetching judge record:', error);
    return null;
  }
};

export const fetchUserApplicationStatus = async (userId) => {
  try {
    const response = await API.get(API_NAME, `/scan/users/${userId}/status`, {});
    return response;
  } catch (error) {
    console.error('Error fetching application status:', error);
    return null;
  }
};

export const getUsersWithPendingReturns = async () => {
  try {
    return await API.get(API_NAME, '/scan/users/pending_returns', {});
  } catch (error) {
    console.error('Error fetching users with pending returns:', error);
    return null;
  }
};

export const checkInHacker = async (
  user_id,
  organizer_email,
  hacker_record
) => {
  const checkInTime = new Date();

  const payload = {
    body: {
      checkedIn: true,
      checkedInBy: organizer_email,
      checkedInAt: checkInTime,
      tshirtSize: hacker_record?.check_in_info?.tshirtSize,
    },
  };

  try {
    await API.put(API_NAME, `/scan/users/${user_id}/forms/check_in_info`, payload);
  } catch (error) {
    console.error('Check in error:', error);
  }
};

export const checkInJudge = async (user_id, organizer_email, judge_record) => {
  const checkInTime = new Date();

  const payload = {
    body: {
      checkedIn: true,
      checkedInBy: organizer_email,
      checkedInAt: checkInTime,
      tshirtSize: judge_record?.check_in_info?.tshirtSize,
    },
  };

  try {
    await API.put(API_NAME, `/scan/judges/${user_id}/forms/check_in_info`, payload);
  } catch (error) {
    console.error('Judge check in error:', error);
  }
};

export const updateWorkshopList = async (user_id, new_workshop_list) => {
  const payload = {
    body: {
      attendedWorkshops: new_workshop_list,
    },
  };

  try {
    await API.put(API_NAME, `/scan/users/${user_id}/forms/workshop_info`, payload);
  } catch (error) {
    console.error('Updating workshop error:', error);
  }
};

export const updateMealInfoList = async (
  user_id,
  newUsedMeals,
  newDietaryRestrictions
) => {
  const payload = {
    body: {
      usedMeals: newUsedMeals,
      dietaryRestrictions: newDietaryRestrictions,
    },
  };

  try {
    await API.put(API_NAME, `/scan/users/${user_id}/forms/meal_info`, payload);
  } catch (error) {
    console.error('Updating meal info error:', error);
  }
};

export const fetchUserActivities = async (userId) => {
  try {
    const response = await API.get(API_NAME, `/scan/users/${userId}/activities`, {});
    return response;
  } catch (error) {
    console.error('Error fetching user activities:', error);
    return null;
  }
};

export const updateUserActivities = async (userId, activities) => {
  const payload = {
    body: activities,
  };

  try {
    await API.post(API_NAME, `/scan/users/${userId}/activities`, payload);
  } catch (error) {
    console.error('Error updating user activities:', error);
    throw error;
  }
};
